<template>
  <div class="type-form-container">
    <FormKit
        type="hidden"
        name="appointmentValidation"
        :validation="selectedType ? 'finished' : 'required'"
    />

    <p class="form-title">Wählen Sie bitte eine Art, wie Sie sprechen möchten:</p>
    <div v-if="loading" class="loading">Laden...</div>
    <div v-else-if="error" class="error">
      {{ error }}
    </div>
    <div v-else class="options">
      <label
          v-for="option in meetingTypes"
          :key="option.name"
          class="radio-label"
      >
        <input
            type="radio"
            v-model="selectedType"
            :value="option.name"
            class="radio-input"
        />
        <span class="radio-text">{{ option.name }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import configService from "@/services/configService";

export default {
  data() {
    return {
      selectedType: null,
      meetingTypes: [],
      loading: true,
      error: null,
    };
  },
  async created() {
    try {
      const configs = await configService.getConfigs();
      if (Array.isArray(configs.meetingTypes) && configs.meetingTypes.length) {
        this.meetingTypes = configs.meetingTypes;
        this.selectedType = null;
        // this.selectedType = this.meetingTypes[0]?.name;
      } else {
        this.error = "Keine verfügbaren Meeting-Typen gefunden.";
      }
    } catch (err) {
      this.error = "Fehler beim Laden der Meeting-Typen.";
    } finally {
      this.loading = false;
    }
  },
  methods: {
    updateSelectedType() {
      this.$emit("updateType", this.selectedType);
    },
  },
  watch: {
    selectedType() {
      this.updateSelectedType();
    },
  },
};
</script>

<style scoped>
.type-form-container {
  height: 100%;
}



.form-title {
  font-size: 18px;
  color: #2c3e50;
  margin-bottom: 20px;
  font-weight: 700;
  text-align: center;
}

.options {
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-height: 300px;

  overflow-y: auto;

}

.radio-label {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}

.radio-label:hover {
  background-color: #f9f9f9;
}

.radio-input {
  margin-right: 12px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.radio-text {
  font-size: 16px;
  color: #34495e;
}

.loading,
.error {
  text-align: center;
  margin: 12px 0;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
}

.loading {
  color: #8e44ad;
  background-color: #f7f1ff;
}

.error {
  color: #e74c3c;
  background-color: #fdecea;
  border: 1px solid #f5b7b1;
}

@media (max-width: 480px) {
  .type-form-container {
    padding: 16px;
  }

  .form-title {
    font-size: 16px;
  }

  .radio-label {
    padding: 10px 12px;
  }

  .radio-text {
    font-size: 14px;
  }
}
</style>
